import api from './api';

const statutsGarantieApi = {
  getAll: () => api.get('/statuts-garantie'),
  create: (data) => api.post('/statuts-garantie', data),
  update: (id, data) => api.put(`/statuts-garantie/${id}`, data),
  delete: (id) => api.delete(`/statuts-garantie/${id}`)
};

export default statutsGarantieApi;
